const getEnvVariables = async (): Promise<typeof window.ENV> => {
    return window.ENV;
};

const bootstrap = async (): Promise<typeof window.ENV> => {
    return getEnvVariables();
};

export default bootstrap;
